import { DefinitionGrid, DefinitionItem } from '~/components/DefinitionGrid'

import * as S from './styles'

export type BriefingRow = {
  label: string
  value: React.ReactNode
}

type Props = {
  rows: BriefingRow[]
  /**
   * O protótipo desenha o briefing de duas formas, e não por descuido: na
   * criação (`.dv360-review-row`) é lista com borda e valor à direita, porque
   * ali as linhas são uma conferência antes de enviar; no cartão do aprovador
   * (`.review-info-grid`) é grade de três colunas com rótulo em cima, que é
   * também o padrão de leitura do `InfoView`.
   */
  layout?: 'rows' | 'grid'
}

/**
 * Linhas de rótulo e valor do briefing offsite, sem fonte de dado.
 *
 * Nasceu dentro do `ReviewStep` da criação, que lê o snapshot do unform, e saiu
 * de lá quando a revisão do anunciante precisou das mesmas linhas vindas de
 * `GET /campaign/:id`. Quem monta as linhas é o chamador; aqui moram só a
 * apresentação e a escolha entre os dois arranjos do desenho.
 *
 * `dl/dt/dd` nos dois casos, como o protótipo: é par de termo e definição, não
 * ênfase de texto.
 */
export const BriefingRows = ({ rows, layout = 'rows' }: Props) => {
  if (layout === 'grid') {
    return (
      <DefinitionGrid>
        {rows.map(row => (
          <DefinitionItem key={row.label} label={row.label}>
            {row.value}
          </DefinitionItem>
        ))}
      </DefinitionGrid>
    )
  }

  return (
    <S.RowList>
      {rows.map(row => (
        <S.Row key={row.label}>
          <dt>{row.label}</dt>
          <dd>{row.value}</dd>
        </S.Row>
      ))}
    </S.RowList>
  )
}
